import { useCallback, useState } from 'react'

export const CONTACT_DIALOGS = {
  add: 'add',
  assign: 'assign',
  tasks: 'tasks',
} as const

export type ContactDialog =
  (typeof CONTACT_DIALOGS)[keyof typeof CONTACT_DIALOGS]

/**
 * Which bulk-bar dialog is open — one at a time — and a counter that ticks
 * on every opening, so the dialog can be remounted onto a blank form rather
 * than reopening on the last answer.
 */
export function useContactDialog() {
  const [dialog, setDialog] = useState<ContactDialog | null>(null)
  const [opening, setOpening] = useState(0)
  const open = useCallback((next: ContactDialog) => {
    setDialog(next)
    setOpening((count) => count + 1)
  }, [])
  const close = useCallback(() => setDialog(null), [])
  return { dialog, opening, open, close }
}
